// Registro único das seções da página da VM.
// Fonte para: sidebar (desktop), chips (mobile), resolução de slug da URL e permissões.
export const GROUPS = [
  { id: 'vm',       label: 'VM' },
  { id: 'hardware', label: 'Hardware' },
  { id: 'rede',     label: 'Rede' },
  { id: 'protecao', label: 'Proteção' },
  { id: 'operacao', label: 'Operação' },
];

const ALL   = ['admin', 'owner', 'readonly'];
const WRITE = ['admin', 'owner'];
const ADMIN = ['admin'];

export const SECTIONS = [
  { slug: 'overview',     label: 'Visão geral',       group: 'vm',       icon: 'activity', roles: ALL },
  { slug: 'console',      label: 'Console',           group: 'vm',       icon: 'monitor',  roles: WRITE },
  { slug: 'cpu-ram',      label: 'CPU / RAM',         group: 'hardware', icon: 'cpu',      roles: ADMIN },
  { slug: 'boot',         label: 'Boot order',        group: 'hardware', icon: 'list',     roles: WRITE },
  { slug: 'cdrom',        label: 'CD / DVD',          group: 'hardware', icon: 'disc',     roles: WRITE },
  { slug: 'disk-io',      label: 'Disco I/O',         group: 'hardware', icon: 'drive',    roles: ADMIN },
  { slug: 'interfaces',   label: 'Interfaces',        group: 'rede',     icon: 'network',  roles: ALL },
  { slug: 'conexoes',     label: 'Conexões',          group: 'rede',     icon: 'plug',     roles: ADMIN },
  { slug: 'backups',      label: 'Backups',           group: 'protecao', icon: 'archive',  roles: WRITE },
  { slug: 'logs',         label: 'Logs de atividade', group: 'operacao', icon: 'file',     roles: ALL },
  { slug: 'solicitacoes', label: 'Solicitações',      group: 'operacao', icon: 'inbox',    roles: WRITE },
];

export const DEFAULT_SECTION = 'overview';

export function roleFor({ isAdmin, isReadonly }) {
  if (isAdmin) return 'admin';
  if (isReadonly) return 'readonly';
  return 'owner';
}

export function visibleSections(role) {
  return SECTIONS.filter(s => s.roles.includes(role));
}

export function groupedSections(role) {
  const visible = visibleSections(role);
  return GROUPS
    .map(g => ({ ...g, items: visible.filter(s => s.group === g.id) }))
    .filter(g => g.items.length > 0);
}

export function resolveSection(slug, role) {
  const s = SECTIONS.find(x => x.slug === slug);
  return s && s.roles.includes(role) ? s.slug : DEFAULT_SECTION;
}

export function sectionPath(vmid, slug) {
  return slug === DEFAULT_SECTION ? `/vm/${vmid}` : `/vm/${vmid}/${slug}`;
}
